
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13552",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13552",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1191",
  "client-types": "static-1.512",
  "data-fetching-client": "static-1.10141",
  "foundations-components": "static-1.8791",
  "foundations-components-legacy": "static-1.1816",
  "foundations-theming": "static-1.4993",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.95",
  "head-dlb": "static-1.5330",
  "hs-test-utils": "static-1.8542",
  "hub-http-shared-msw-handlers": "static-1.10948",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11990",
  "I18n": "static-7.1715",
  "jasmine-runner": "static-1.6956",
  "marketplace-discovery-studio-lib": "static-1.949",
  "marketplace-storefront-base": "static-1.13615",
  "quartz": "static-1.7694",
  "react-dlb": "static-1.96",
  "react-rhumb": "static-1.17242",
  "reactive-variable-buffer-atom": "static-1.3354",
  "reporting-testing-lib": "static-1.11395",
  "reselect": "static-3.18",
  "settings-ui-lib": "static-1.13031",
  "SharedI18nStrings": "static-1.190",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7891",
  "ui-addon-i18n": "static-1.11648",
  "ui-addon-react-router-dom": "static-1.10028",
  "unified-auth": "static-1.1307",
  "unified-auth-core-lib": "static-1.1589",
  "usage-tracker": "static-1.7825",
  "usage-tracker-core": "static-1.7675",
  "customer-data-property-utils": "static-1.8556",
  "hub-http": "static-1.6709",
  "integrations-lib": "static-1.17486",
  "marketplace-ui-common": "static-1.21076",
  "marketplace-ui-install": "static-1.1062",
  "property-management-iframe": "static-1.14517",
  "quartz-config": "static-1.1472",
  "quartz-core": "static-1.6913",
  "quartz-routing": "static-1.1124",
  "quick-fetch": "static-1.4245",
  "react": "static-7.204",
  "rpc-client-utils": "static-1.5169",
  "ts-schema": "static-1.4409",
  "ui-universal-auth": "static-1.9793",
  "UIComponents": "static-3.8936",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.523",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven": "static-3.6411",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3971",
  "quartz-webpack": "static-1.3918",
  "bend-plugin-quartz-routing": "static-1.772",
  "ai-components-ui-library": "static-1.10069",
  "codemirror": "static-5.108",
  "foundations-assets": "static-1.5392",
  "pulse": "static-1.1154",
  "react-codemirror": "static-1.11146",
  "ui-extensions-preview-lib": "static-1.1030",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5060",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2709",
  "framer-motion": "static-1.86",
  "hs-story-utils": "static-1.9931",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.111",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5681",
  "react-virtualized": "static-2.114",
  "StyleGuideUI": "static-3.520",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3158",
  "ui-fonts": "static-1.1252",
  "ui-images": "static-2.1283",
  "bend-plugin-foundations-theming": "static-1.3476",
  "foundations-theming-base": "static-1.3978",
  "stylex": "static-1.48",
  "HeadJS": "static-2.829",
  "hs-test-utils-bend-plugin": "static-1.3653",
  "msw": "static-1.105",
  "msw-config": "static-1.35",
  "testing-library": "static-1.167",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4809",
  "ui-addon-video-player": "static-1.9126",
  "ai-rendering-library": "static-1.11450",
  "chirp-fetch": "static-1.2408",
  "connections-embed-lib": "static-1.1796",
  "copilot-toolkit": "static-1.12199",
  "feedback-loader": "static-1.30100",
  "laboratory-lib": "static-3.7650",
  "marketplace-embed": "static-1.23246",
  "marketplace-ui-details": "static-1.10971",
  "marketplace-ui-reviews": "static-1.21031",
  "marketplace-ui-tracking": "static-1.15246",
  "sanitize-text": "static-1.8661",
  "usage-tracker-multi": "static-1.6239",
  "usage-tracker-session-replay": "static-1.5511",
  "beacon-keepalive-queue": "static-1.202",
  "quartz-head": "static-1.1359",
  "web-vitals": "static-1.21",
  "apollo-link-hub-http": "static-2.5092",
  "immer": "static-1.107",
  "immerable": "static-1.4646",
  "highcharts": "static-8.117",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2862",
  "reporting-data": "static-1.69462",
  "cssUtils": "static-1.1125",
  "flux-actions": "static-1.383",
  "react-colorpicker": "static-2.10712",
  "react-dnd-compat": "static-1.5111",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10873",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7815",
  "icons": "static-2.709",
  "marketplace-ui-apps-core": "static-1.19608",
  "storybook-react": "static-1.46",
  "trellis-story-utils": "static-1.5002",
  "foundations-components-test-utils": "static-1.6274",
  "quartz-i18n": "static-1.1369",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.788",
  "ads-unified-auth-lib": "static-1.2145",
  "ai-mcp-auth-lib": "static-1.50",
  "custom-vendor-connection-lib": "static-1.357",
  "gemini-settings-lib": "static-1.9831",
  "google-sheets-integration-lib": "static-1.1379",
  "microsoft-drive-auth-lib": "static-1.571",
  "slack-ui-library": "static-1.10903",
  "surveymonkey-integration-lib": "static-1.894",
  "fsm": "static-1.4260",
  "customer-data-objects": "static-1.8214",
  "property-translator": "static-1.5884",
  "hs-locale-management": "static-1.416",
  "frontend-preferences-client": "static-1.8424",
  "hs-promise-utils": "static-1.6094",
  "hubspot-apollo-client": "static-1.5385",
  "integrations-error-boundary-lib": "static-1.14901",
  "integrations-tracking-lib": "static-1.6126",
  "native-integrations-shared-strings": "static-1.8265",
  "sanitize": "static-1.4973",
  "superstore": "static-1.5261",
  "ui-shepherd-react": "static-3.10784",
  "ai-settings-ui-library": "static-1.8633",
  "hub-http-janus": "static-1.913",
  "hubspotter-http": "static-1.4989",
  "immutable-less": "static-1.5154",
  "marketplace-ui-client-types": "static-1.18483",
  "nav-meta": "static-1.30856",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18566",
  "ui-product-approvals-common": "static-1.1672",
  "ai-studio-lib": "static-1.12822",
  "hubspot-prosemirror": "static-1.19329",
  "integrations-reconnect-lib": "static-1.769",
  "ui-addon-iframeable": "static-1.9582",
  "ui-addon-integrations-directory-panel": "static-2.8457",
  "ui-product-approvals": "static-1.29777",
  "ui-tool-access": "static-1.10661",
  "inbound-db-properties-service-client": "static-1.4165",
  "property-management-common": "static-1.6805",
  "opentelemetry-fe-types": "static-1.295",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.670",
  "quartz-auth": "static-1.1369",
  "quartz-test": "static-1.1369",
  "quartz-tracking": "static-1.1073",
  "trellis-components": "static-1.3177",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.579",
  "HubStyle": "static-2.12297",
  "bender-build-tools": "static-1.3617",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.24038",
  "ContentUtils": "static-1.69535",
  "customer-data-objects-ui-components": "static-1.13539",
  "sassPrefix": "static-1.390",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2053",
  "bend-plugin-pulse": "static-1.657",
  "event-emitter": "static-1.1464",
  "fast-json-patch": "static-1.76",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5932",
  "magpie-types": "static-1.5392",
  "stylex-utils": "static-1.182",
  "trellis-theming": "static-1.1519",
  "avatar-components": "static-1.2991",
  "breeze-engine-core": "static-1.1544",
  "breeze-engine-lib": "static-1.2266",
  "breeze-onboarding-components": "static-1.1123",
  "customer-data-filters-ui": "static-1.41451",
  "customer-data-reference-ui-components": "static-1.13678",
  "data-integrations-breeze": "static-1.382",
  "embedded-academy-lib": "static-1.16087",
  "ExportDialog": "static-6.10876",
  "global-styles-ai-lib": "static-1.549",
  "highlight.js": "static-1.92",
  "markdown-it": "static-1.6",
  "marketplace-embed-ba": "static-1.949",
  "mermaid": "static-1.47",
  "reporting-action-components": "static-1.42463",
  "reporting-snowflake": "static-1.58078",
  "reporting-ui-components": "static-2.66731",
  "reporting-visualizations": "static-1.61536",
  "trial-components-library": "static-1.14429",
  "ui-addon-teams": "static-1.22043",
  "upgrade-components-lib": "static-1.762",
  "navigation-components": "static-1.19219",
  "nest": "static-1.740",
  "simple-logging-lib": "static-1.3554",
  "nudge-client-utils": "static-1.3461",
  "fail-safe": "static-1.453",
  "app-governance-lib": "static-1.2789",
  "developer-experience-shared-components": "static-1.11045",
  "purchase-motions-components": "static-1.6668",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10854",
  "usage-tracker-anonymous": "static-1.6242",
  "usage-tracker-public": "static-1.7636",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3789",
  "persist-promise": "static-1.4210",
  "reference-resolvers": "static-1.8687",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4418",
  "hubspot-apollo-cache": "static-1.844",
  "universal-page-editor-lib": "static-1.3516",
  "final-form": "static-1.85",
  "redux-toolkit": "static-1.84",
  "simple-data-table": "static-1.3865",
  "merchandise-lib": "static-1.288",
  "onboarding-scopes": "static-1.6956",
  "ui-addon-draggable": "static-3.5254",
  "content-assistance-lib": "static-1.8460",
  "content-media-capture": "static-1.5836",
  "customer-data-ui-utilities": "static-1.10335",
  "emoji-mart": "static-3.9",
  "file-manager-components": "static-1.24884",
  "growth-payments-core": "static-1.26550",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3385",
  "payment-link-components": "static-1.24510",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20595",
  "ui-addon-emoji-picker": "static-1.10367",
  "ui-business-units-lib": "static-1.9600",
  "video-components-external": "static-1.12492",
  "video-data-lib": "static-1.36150",
  "navigation-messaging": "static-1.8546",
  "collaboration-sidebar": "static-1.59113",
  "trellis-ext-dnd": "static-1.583",
  "crm-component-utils": "static-1.40263",
  "crm-properties-common-lib": "static-1.6401",
  "customer-data-properties": "static-1.53138",
  "external-options-client-types": "static-1.4453",
  "hs-resources": "static-1.688",
  "property-value-citations": "static-1.3752",
  "reference-resolvers-lite": "static-1.8617",
  "opentelemetry-web": "static-1.25",
  "hubspotter-http-shared-msw-handlers": "static-1.10946",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "cms-field-types": "static-1.5314",
  "content-icons-ui": "static-1.2484",
  "atom": "static-1.5575",
  "idb-keyval": "static-1.57",
  "reactive-lib": "static-1.1223",
  "trellis-migration-context": "static-1.81",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1244",
  "breeze-artifacts-sdk": "static-1.1077",
  "breeze-assistant-components": "static-1.2526",
  "getting-started-shared-tasks": "static-1.19611",
  "onboarding-journeys-lib": "static-1.1290",
  "conversations-skeleton-state": "static-1.7621",
  "crm-message-bus": "static-1.44160",
  "customer-data-filters-ui-msw-helpers": "static-1.23886",
  "events-data-lib": "static-1.750",
  "FormUrlGenerator": "static-2.5217",
  "framework-builder-read-service-client": "static-1.4350",
  "multi-account-reference-resolvers": "static-1.1516",
  "onboarding-tours": "static-1.17428",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14815",
  "segments-client-types": "static-1.12270",
  "academy-common-lib": "static-1.15548",
  "dashboard-lib": "static-1.83369",
  "hubspot-prosemirror-plugins": "static-1.19321",
  "reporting-plugins": "static-1.11044",
  "share-with-third-party-component-lib": "static-1.9214",
  "ui-asset-management-lib": "static-1.11605",
  "user-context": "static-1.5558",
  "reporting-reports": "static-1.69138",
  "hubs-service-types": "static-1.1770",
  "purchase-motions-api": "static-1.6671",
  "salesImages": "static-1.760",
  "signup-constants": "static-1.19994",
  "nudge-custom-function-registry": "static-1.3218",
  "nudge-renderer-utils": "static-1.3537",
  "whisper-core-api": "static-1.7675",
  "bend-plugin-fail-safe": "static-1.404",
  "framework-listing-lib": "static-2.29862",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31803",
  "apps-service-types": "static-1.4113",
  "oauth-service-types": "static-1.4639",
  "signup-ui-url-generator": "static-2.8541",
  "onboarding-tours-client": "static-1.5643",
  "one-click-checkout": "static-1.782",
  "platform-infra-nav-components": "static-1.8016",
  "subscription-experience-data-types": "static-1.15473",
  "crm-record-cards-client": "static-1.117",
  "crm-record-cards-service-types": "static-1.3876",
  "framework-data-schema-resolvers": "static-1.7396",
  "location-customization-utils-lib": "static-1.10472",
  "redux-thunk": "static-2.86",
  "react-flip-move": "static-1.85",
  "ui-coaching-tips": "static-1.29612",
  "content-media-composition-data-lib": "static-1.13640",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4933",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3980",
  "seat-types-lib": "static-1.1097",
  "ui-addon-opt": "static-4.8920",
  "commerce-tours-lib": "static-1.6901",
  "growth-onboarding-reliability": "static-1.5587",
  "sales-checkout-service-client": "static-1.4025",
  "data-token-picker": "static-1.17176",
  "FileManagerLib": "static-1.40524",
  "content-media-compositions": "static-2.17647",
  "media-bridge-lib": "static-1.19680",
  "chatspot-widget-iframe": "static-1.24029",
  "collaboration-sidebar-common": "static-1.3910",
  "marketing-platform-lib": "static-1.7410",
  "dnd-kit": "static-1.23",
  "commerce-subscription-lib": "static-1.38102",
  "crm-actions": "static-1.6891",
  "crm-cards-sdk": "static-1.45088",
  "customer-data-properties-shared-msw-handlers": "static-1.10275",
  "customer-data-tracking": "static-1.7375",
  "calling-global-api": "static-1.66278",
  "calling-internal-common": "static-1.31827",
  "calling-lifecycle-internal": "static-1.67660",
  "calling-lifecycle-messages": "static-1.59952",
  "commerce-products-lib": "static-1.10977",
  "conditional-properties-service-client": "static-1.4128",
  "crm-index-visualization-core": "static-1.4795",
  "crm-links": "static-1.6816",
  "crm-pipelines-api-client-types": "static-1.4458",
  "data-agent-utils": "static-1.975",
  "formula-editor": "static-1.15046",
  "google-libphonenumber": "static-1.52",
  "inbounddb-objects-service-types": "static-1.4529",
  "meetings-icalendar-utils-lib": "static-1.1135",
  "multi-currency-client-types": "static-1.4023",
  "object-builder-ui-client": "static-1.50110",
  "pipeline-validation-client-types": "static-1.4298",
  "react-tinymce": "static-1.56317",
  "smart-data-capture-core": "static-1.537",
  "tiered-pricing": "static-1.2327",
  "tinymce-config": "static-2.55443",
  "tinymce-plugins": "static-1.58557",
  "tinymce-themes": "static-1.57413",
  "topics-actions-lib": "static-1.688",
  "trellis-ext-i18n": "static-1.1427",
  "ui-addon-form-validation": "static-1.11352",
  "zustand": "static-1.91",
  "fdsr-migration-layer": "static-1.515",
  "breeze-sharing-core": "static-1.45",
  "restore-request-side-panel-lib": "static-1.2086",
  "growth-data-modal": "static-1.6170",
  "growth-onboarding-confetti": "static-1.3561",
  "growth-onboarding-next-action-utils": "static-1.3032",
  "onboarding-tours-utils": "static-1.1495",
  "ui-shepherd-tracker": "static-1.8165",
  "crm-index-associations-lib": "static-1.6952",
  "academy-service-client": "static-1.4195",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40383",
  "SafeStorage": "static-1.4898",
  "video-embed": "static-1.36984",
  "wootric-nps": "static-1.7312",
  "redux-actions": "static-3.76",
  "EmailSignatureEditor": "static-1.25293",
  "viral-links-lib": "static-1.7586",
  "campaign-roi-lib": "static-1.10890",
  "campaigns-utils-lib": "static-1.3755",
  "ui-addon-calendars": "static-2.5870",
  "nested-table": "static-1.730",
  "timezone-utils": "static-2.5733",
  "getting-started-shared-tasks-store": "static-1.18729",
  "customer-data-views-management": "static-1.26402",
  "framework-data-table": "static-2.12882",
  "nudge-custom-ui-functions": "static-1.1777",
  "switchboard-lib": "static-1.741",
  "access-check-ui-lib": "static-1.1935",
  "app-users-service-client": "static-1.6123",
  "app-users-service-types": "static-1.5531",
  "mini-checkout-client": "static-1.27877",
  "onboarding-utils": "static-1.5877",
  "permissions-shared-i18n-strings-fe": "static-1.2145",
  "ui-coaching-tips-shared-config": "static-1.29597",
  "checkout-sdk": "static-3.24720",
  "payment-method-components": "static-1.7347",
  "touchless-buying-components": "static-1.6588",
  "upgrade-catalog-service-types": "static-1.3902",
  "edison-service-client-types": "static-1.895",
  "framework-data-schema-quick-fetch": "static-1.7301",
  "growth-onboarding-feedback-components": "static-1.7084",
  "audio-components": "static-1.6610",
  "FileManagerImages": "static-1.38035",
  "video-components": "static-1.14494",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20541",
  "commerce-shared-components-lib": "static-1.19624",
  "commerce-tools-ui-lib": "static-1.11371",
  "crm_data": "static-4.93260",
  "crm-activity-creator-data": "static-1.47808",
  "crm-fe-perf": "static-1.23402",
  "universal-record-utils-lib": "static-1.2419",
  "calling-error-reporting": "static-1.31834",
  "shared-worker-versioning": "static-1.11546",
  "calling-usage-tracker": "static-1.7044",
  "voice-sms-access-library": "static-1.2534",
  "commerce-permissions": "static-1.1290",
  "products-iframe-lib": "static-1.8966",
  "products-ui-components-shared-msw-handlers": "static-1.11330",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11031",
  "sales-views-client-types": "static-1.4761",
  "data-agent-kit": "static-1.962",
  "enrichment-settings-lib": "static-1.300",
  "policy-lib": "static-1.7308",
  "bark-lib": "static-1.17037",
  "browser-prettier": "static-1.11",
  "tinymce": "static-5.11",
  "hub-http-contrib": "static-1.3535",
  "interframe": "static-3.5246",
  "tinymce-data": "static-1.41528",
  "ui-addon-sales-email": "static-1.5706",
  "layout-dnd-components": "static-1.13267",
  "layout-dnd-utils": "static-1.12242",
  "ui-brand-identity-lib": "static-1.17012",
  "NamespacedHubStyle": "static-2.9382",
  "onboarding-data-sync-lib": "static-1.2875",
  "growth-onboarding-next-action-components": "static-1.3060",
  "user-context-client": "static-1.5012",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.67",
  "urlinator": "static-1.5017",
  "outpost": "static-1.4633",
  "draft-convert": "static-2.86",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22399",
  "sales-email-signature-service-client": "static-1.4351",
  "copilot-messaging": "static-1.2449",
  "ts-utils-lib": "static-1.655",
  "crm-export-dialog": "static-1.6781",
  "crm-index-ui-shimmer": "static-1.3044",
  "crm-view-components": "static-1.1564",
  "react-beautiful-dnd": "static-1.77",
  "customer-data-associations": "static-1.7841",
  "tasks-actions-lib": "static-1.485",
  "InboxConnectUtils": "static-4.15888",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.887",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4491",
  "company-details-components": "static-1.6710",
  "react-performance-metrics-lib": "static-1.1053",
  "pricing-pages-ui-components": "static-1.16671",
  "quote-checkout-service-types": "static-1.3962",
  "social-insights-client-types": "static-1.22976",
  "utility-belt": "static-1.3041",
  "payments-enrollment-embed-lib": "static-1.24286",
  "stripe-embedded-components": "static-1.8287",
  "customer-data-rte": "static-1.33945",
  "cv-backend-services": "static-1.1611",
  "growth-onboarding-empty-states": "static-1.6576",
  "payments-post-enroll-local-storage-lib": "static-1.5609",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39214",
  "crm_universal": "static-1.22764",
  "customer-data-email": "static-1.18682",
  "meetings-rte-lib": "static-1.586",
  "universal-associations-select": "static-1.11601",
  "crm-object-search-query-utilities": "static-1.10503",
  "calling-orchestration-schema": "static-1.37311",
  "react-reducer-toolkit": "static-1.16714",
  "ContentData": "static-1.69611",
  "layout-data-lib": "static-1.10567",
  "meetings-connect-utils-lib": "static-1.8123",
  "company-details-service-types": "static-1.4448",
  "segments-query-core": "static-1.1934",
  "pricing-pages-api": "static-1.16536",
  "stripe-connect-js": "static-1.85",
  "draft-content-plugins": "static-1.29199",
  "sequences-lib": "static-1.8823",
  "ui-gdpr-components": "static-1.10658",
  "meetings-client-types": "static-1.4094",
  "meetings-core": "static-1.808",
  "advanced-menus-core": "static-1.15859",
  "advanced-menus-lib": "static-1.12602",
  "ui-memberships-settings-lib": "static-1.35252",
  "sequences-client-types-lib": "static-1.8680",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15858",
  "simple-menus-lib": "static-1.17375"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13552",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1191",
  "client-types": "/client-types/static-1.512",
  "data-fetching-client": "/data-fetching-client/static-1.10141",
  "foundations-components": "/foundations-components/static-1.8791",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1816",
  "foundations-theming": "/foundations-theming/static-1.4993",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.95",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-test-utils": "/hs-test-utils/static-1.8542",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10948",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11990",
  "I18n": "/I18n/static-7.1715",
  "jasmine-runner": "/jasmine-runner/static-1.6956",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.949",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13615",
  "quartz": "/quartz/static-1.7694",
  "react-dlb": "/react-dlb/static-1.96",
  "react-rhumb": "/react-rhumb/static-1.17242",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3354",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11395",
  "reselect": "/reselect/static-3.18",
  "settings-ui-lib": "/settings-ui-lib/static-1.13031",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7891",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11648",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10028",
  "unified-auth": "/unified-auth/static-1.1307",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1589",
  "usage-tracker": "/usage-tracker/static-1.7825",
  "usage-tracker-core": "/usage-tracker-core/static-1.7675",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8556",
  "hub-http": "/hub-http/static-1.6709",
  "integrations-lib": "/integrations-lib/static-1.17486",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21076",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1062",
  "property-management-iframe": "/property-management-iframe/static-1.14517",
  "quartz-config": "/quartz-config/static-1.1472",
  "quartz-core": "/quartz-core/static-1.6913",
  "quartz-routing": "/quartz-routing/static-1.1124",
  "quick-fetch": "/quick-fetch/static-1.4245",
  "react": "/react/static-7.204",
  "rpc-client-utils": "/rpc-client-utils/static-1.5169",
  "ts-schema": "/ts-schema/static-1.4409",
  "ui-universal-auth": "/ui-universal-auth/static-1.9793",
  "UIComponents": "/UIComponents/static-3.8936",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.523",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven": "/raven/static-3.6411",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3971",
  "quartz-webpack": "/quartz-webpack/static-1.3918",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.772",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10069",
  "codemirror": "/codemirror/static-5.108",
  "foundations-assets": "/foundations-assets/static-1.5392",
  "pulse": "/pulse/static-1.1154",
  "react-codemirror": "/react-codemirror/static-1.11146",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.1030",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5060",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2709",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-story-utils": "/hs-story-utils/static-1.9931",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.111",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5681",
  "react-virtualized": "/react-virtualized/static-2.114",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3158",
  "ui-fonts": "/ui-fonts/static-1.1252",
  "ui-images": "/ui-images/static-2.1283",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3476",
  "foundations-theming-base": "/foundations-theming-base/static-1.3978",
  "stylex": "/stylex/static-1.48",
  "HeadJS": "/HeadJS/static-2.829",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3653",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.35",
  "testing-library": "/testing-library/static-1.167",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4809",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9126",
  "ai-rendering-library": "/ai-rendering-library/static-1.11450",
  "chirp-fetch": "/chirp-fetch/static-1.2408",
  "connections-embed-lib": "/connections-embed-lib/static-1.1796",
  "copilot-toolkit": "/copilot-toolkit/static-1.12199",
  "feedback-loader": "/feedback-loader/static-1.30100",
  "laboratory-lib": "/laboratory-lib/static-3.7650",
  "marketplace-embed": "/marketplace-embed/static-1.23246",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10971",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21031",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15246",
  "sanitize-text": "/sanitize-text/static-1.8661",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6239",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5511",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.202",
  "quartz-head": "/quartz-head/static-1.1359",
  "web-vitals": "/web-vitals/static-1.21",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5092",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4646",
  "highcharts": "/highcharts/static-8.117",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2862",
  "reporting-data": "/reporting-data/static-1.69462",
  "cssUtils": "/cssUtils/static-1.1125",
  "flux-actions": "/flux-actions/static-1.383",
  "react-colorpicker": "/react-colorpicker/static-2.10712",
  "react-dnd-compat": "/react-dnd-compat/static-1.5111",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10873",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7815",
  "icons": "/icons/static-2.709",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19608",
  "storybook-react": "/storybook-react/static-1.46",
  "trellis-story-utils": "/trellis-story-utils/static-1.5002",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6274",
  "quartz-i18n": "/quartz-i18n/static-1.1369",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.788",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2145",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.50",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.357",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9831",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1379",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.571",
  "slack-ui-library": "/slack-ui-library/static-1.10903",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.894",
  "fsm": "/fsm/static-1.4260",
  "customer-data-objects": "/customer-data-objects/static-1.8214",
  "property-translator": "/property-translator/static-1.5884",
  "hs-locale-management": "/hs-locale-management/static-1.416",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8424",
  "hs-promise-utils": "/hs-promise-utils/static-1.6094",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5385",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14901",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6126",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8265",
  "sanitize": "/sanitize/static-1.4973",
  "superstore": "/superstore/static-1.5261",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10784",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8633",
  "hub-http-janus": "/hub-http-janus/static-1.913",
  "hubspotter-http": "/hubspotter-http/static-1.4989",
  "immutable-less": "/immutable-less/static-1.5154",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18483",
  "nav-meta": "/nav-meta/static-1.30856",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18566",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1672",
  "ai-studio-lib": "/ai-studio-lib/static-1.12822",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19329",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.769",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9582",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8457",
  "ui-product-approvals": "/ui-product-approvals/static-1.29777",
  "ui-tool-access": "/ui-tool-access/static-1.10661",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4165",
  "property-management-common": "/property-management-common/static-1.6805",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.295",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.670",
  "quartz-auth": "/quartz-auth/static-1.1369",
  "quartz-test": "/quartz-test/static-1.1369",
  "quartz-tracking": "/quartz-tracking/static-1.1073",
  "trellis-components": "/trellis-components/static-1.3177",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.579",
  "HubStyle": "/HubStyle/static-2.12297",
  "bender-build-tools": "/bender-build-tools/static-1.3617",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.24038",
  "ContentUtils": "/ContentUtils/static-1.69535",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13539",
  "sassPrefix": "/sassPrefix/static-1.390",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2053",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.657",
  "event-emitter": "/event-emitter/static-1.1464",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5932",
  "magpie-types": "/magpie-types/static-1.5392",
  "stylex-utils": "/stylex-utils/static-1.182",
  "trellis-theming": "/trellis-theming/static-1.1519",
  "avatar-components": "/avatar-components/static-1.2991",
  "breeze-engine-core": "/breeze-engine-core/static-1.1544",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2266",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1123",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41451",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13678",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.382",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16087",
  "ExportDialog": "/ExportDialog/static-6.10876",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.549",
  "highlight.js": "/highlight.js/static-1.92",
  "markdown-it": "/markdown-it/static-1.6",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.949",
  "mermaid": "/mermaid/static-1.47",
  "reporting-action-components": "/reporting-action-components/static-1.42463",
  "reporting-snowflake": "/reporting-snowflake/static-1.58078",
  "reporting-ui-components": "/reporting-ui-components/static-2.66731",
  "reporting-visualizations": "/reporting-visualizations/static-1.61536",
  "trial-components-library": "/trial-components-library/static-1.14429",
  "ui-addon-teams": "/ui-addon-teams/static-1.22043",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.762",
  "navigation-components": "/navigation-components/static-1.19219",
  "nest": "/nest/static-1.740",
  "simple-logging-lib": "/simple-logging-lib/static-1.3554",
  "nudge-client-utils": "/nudge-client-utils/static-1.3461",
  "fail-safe": "/fail-safe/static-1.453",
  "app-governance-lib": "/app-governance-lib/static-1.2789",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11045",
  "purchase-motions-components": "/purchase-motions-components/static-1.6668",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10854",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6242",
  "usage-tracker-public": "/usage-tracker-public/static-1.7636",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3789",
  "persist-promise": "/persist-promise/static-1.4210",
  "reference-resolvers": "/reference-resolvers/static-1.8687",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4418",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.844",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3516",
  "final-form": "/final-form/static-1.85",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "simple-data-table": "/simple-data-table/static-1.3865",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "onboarding-scopes": "/onboarding-scopes/static-1.6956",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5254",
  "content-assistance-lib": "/content-assistance-lib/static-1.8460",
  "content-media-capture": "/content-media-capture/static-1.5836",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10335",
  "emoji-mart": "/emoji-mart/static-3.9",
  "file-manager-components": "/file-manager-components/static-1.24884",
  "growth-payments-core": "/growth-payments-core/static-1.26550",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3385",
  "payment-link-components": "/payment-link-components/static-1.24510",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20595",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10367",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9600",
  "video-components-external": "/video-components-external/static-1.12492",
  "video-data-lib": "/video-data-lib/static-1.36150",
  "navigation-messaging": "/navigation-messaging/static-1.8546",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59113",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.583",
  "crm-component-utils": "/crm-component-utils/static-1.40263",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6401",
  "customer-data-properties": "/customer-data-properties/static-1.53138",
  "external-options-client-types": "/external-options-client-types/static-1.4453",
  "hs-resources": "/hs-resources/static-1.688",
  "property-value-citations": "/property-value-citations/static-1.3752",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8617",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10946",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "cms-field-types": "/cms-field-types/static-1.5314",
  "content-icons-ui": "/content-icons-ui/static-1.2484",
  "atom": "/atom/static-1.5575",
  "idb-keyval": "/idb-keyval/static-1.57",
  "reactive-lib": "/reactive-lib/static-1.1223",
  "trellis-migration-context": "/trellis-migration-context/static-1.81",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1244",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1077",
  "breeze-assistant-components": "/breeze-assistant-components/static-1.2526",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19611",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1290",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7621",
  "crm-message-bus": "/crm-message-bus/static-1.44160",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23886",
  "events-data-lib": "/events-data-lib/static-1.750",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5217",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4350",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1516",
  "onboarding-tours": "/onboarding-tours/static-1.17428",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14815",
  "segments-client-types": "/segments-client-types/static-1.12270",
  "academy-common-lib": "/academy-common-lib/static-1.15548",
  "dashboard-lib": "/dashboard-lib/static-1.83369",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19321",
  "reporting-plugins": "/reporting-plugins/static-1.11044",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9214",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11605",
  "user-context": "/user-context/static-1.5558",
  "reporting-reports": "/reporting-reports/static-1.69138",
  "hubs-service-types": "/hubs-service-types/static-1.1770",
  "purchase-motions-api": "/purchase-motions-api/static-1.6671",
  "salesImages": "/salesImages/static-1.760",
  "signup-constants": "/signup-constants/static-1.19994",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3218",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3537",
  "whisper-core-api": "/whisper-core-api/static-1.7675",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.404",
  "framework-listing-lib": "/framework-listing-lib/static-2.29862",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31803",
  "apps-service-types": "/apps-service-types/static-1.4113",
  "oauth-service-types": "/oauth-service-types/static-1.4639",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8541",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5643",
  "one-click-checkout": "/one-click-checkout/static-1.782",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8016",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15473",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.117",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3876",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7396",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10472",
  "redux-thunk": "/redux-thunk/static-2.86",
  "react-flip-move": "/react-flip-move/static-1.85",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29612",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13640",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4933",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3980",
  "seat-types-lib": "/seat-types-lib/static-1.1097",
  "ui-addon-opt": "/ui-addon-opt/static-4.8920",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6901",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5587",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4025",
  "data-token-picker": "/data-token-picker/static-1.17176",
  "FileManagerLib": "/FileManagerLib/static-1.40524",
  "content-media-compositions": "/content-media-compositions/static-2.17647",
  "media-bridge-lib": "/media-bridge-lib/static-1.19680",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.24029",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3910",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7410",
  "dnd-kit": "/dnd-kit/static-1.23",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38102",
  "crm-actions": "/crm-actions/static-1.6891",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45088",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10275",
  "customer-data-tracking": "/customer-data-tracking/static-1.7375",
  "calling-global-api": "/calling-global-api/static-1.66278",
  "calling-internal-common": "/calling-internal-common/static-1.31827",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67660",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59952",
  "commerce-products-lib": "/commerce-products-lib/static-1.10977",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4128",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4795",
  "crm-links": "/crm-links/static-1.6816",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4458",
  "data-agent-utils": "/data-agent-utils/static-1.975",
  "formula-editor": "/formula-editor/static-1.15046",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4529",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1135",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4023",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50110",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4298",
  "react-tinymce": "/react-tinymce/static-1.56317",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.537",
  "tiered-pricing": "/tiered-pricing/static-1.2327",
  "tinymce-config": "/tinymce-config/static-2.55443",
  "tinymce-plugins": "/tinymce-plugins/static-1.58557",
  "tinymce-themes": "/tinymce-themes/static-1.57413",
  "topics-actions-lib": "/topics-actions-lib/static-1.688",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1427",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "zustand": "/zustand/static-1.91",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.515",
  "breeze-sharing-core": "/breeze-sharing-core/static-1.45",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2086",
  "growth-data-modal": "/growth-data-modal/static-1.6170",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3561",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3032",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1495",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8165",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6952",
  "academy-service-client": "/academy-service-client/static-1.4195",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40383",
  "SafeStorage": "/SafeStorage/static-1.4898",
  "video-embed": "/video-embed/static-1.36984",
  "wootric-nps": "/wootric-nps/static-1.7312",
  "redux-actions": "/redux-actions/static-3.76",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25293",
  "viral-links-lib": "/viral-links-lib/static-1.7586",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10890",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3755",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5870",
  "nested-table": "/nested-table/static-1.730",
  "timezone-utils": "/timezone-utils/static-2.5733",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18729",
  "customer-data-views-management": "/customer-data-views-management/static-1.26402",
  "framework-data-table": "/framework-data-table/static-2.12882",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1777",
  "switchboard-lib": "/switchboard-lib/static-1.741",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1935",
  "app-users-service-client": "/app-users-service-client/static-1.6123",
  "app-users-service-types": "/app-users-service-types/static-1.5531",
  "mini-checkout-client": "/mini-checkout-client/static-1.27877",
  "onboarding-utils": "/onboarding-utils/static-1.5877",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2145",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29597",
  "checkout-sdk": "/checkout-sdk/static-3.24720",
  "payment-method-components": "/payment-method-components/static-1.7347",
  "touchless-buying-components": "/touchless-buying-components/static-1.6588",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3902",
  "edison-service-client-types": "/edison-service-client-types/static-1.895",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7301",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7084",
  "audio-components": "/audio-components/static-1.6610",
  "FileManagerImages": "/FileManagerImages/static-1.38035",
  "video-components": "/video-components/static-1.14494",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20541",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19624",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11371",
  "crm_data": "/crm_data/static-4.93260",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47808",
  "crm-fe-perf": "/crm-fe-perf/static-1.23402",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2419",
  "calling-error-reporting": "/calling-error-reporting/static-1.31834",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11546",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7044",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2534",
  "commerce-permissions": "/commerce-permissions/static-1.1290",
  "products-iframe-lib": "/products-iframe-lib/static-1.8966",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11330",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11031",
  "sales-views-client-types": "/sales-views-client-types/static-1.4761",
  "data-agent-kit": "/data-agent-kit/static-1.962",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.300",
  "policy-lib": "/policy-lib/static-1.7308",
  "bark-lib": "/bark-lib/static-1.17037",
  "browser-prettier": "/browser-prettier/static-1.11",
  "tinymce": "/tinymce/static-5.11",
  "hub-http-contrib": "/hub-http-contrib/static-1.3535",
  "interframe": "/interframe/static-3.5246",
  "tinymce-data": "/tinymce-data/static-1.41528",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5706",
  "layout-dnd-components": "/layout-dnd-components/static-1.13267",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12242",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17012",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9382",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2875",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3060",
  "user-context-client": "/user-context-client/static-1.5012",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.67",
  "urlinator": "/urlinator/static-1.5017",
  "outpost": "/outpost/static-1.4633",
  "draft-convert": "/draft-convert/static-2.86",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22399",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4351",
  "copilot-messaging": "/copilot-messaging/static-1.2449",
  "ts-utils-lib": "/ts-utils-lib/static-1.655",
  "crm-export-dialog": "/crm-export-dialog/static-1.6781",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.3044",
  "crm-view-components": "/crm-view-components/static-1.1564",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.77",
  "customer-data-associations": "/customer-data-associations/static-1.7841",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.485",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15888",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.887",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4491",
  "company-details-components": "/company-details-components/static-1.6710",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1053",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16671",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3962",
  "social-insights-client-types": "/social-insights-client-types/static-1.22976",
  "utility-belt": "/utility-belt/static-1.3041",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24286",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8287",
  "customer-data-rte": "/customer-data-rte/static-1.33945",
  "cv-backend-services": "/cv-backend-services/static-1.1611",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6576",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5609",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39214",
  "crm_universal": "/crm_universal/static-1.22764",
  "customer-data-email": "/customer-data-email/static-1.18682",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.586",
  "universal-associations-select": "/universal-associations-select/static-1.11601",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10503",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37311",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16714",
  "ContentData": "/ContentData/static-1.69611",
  "layout-data-lib": "/layout-data-lib/static-1.10567",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8123",
  "company-details-service-types": "/company-details-service-types/static-1.4448",
  "segments-query-core": "/segments-query-core/static-1.1934",
  "pricing-pages-api": "/pricing-pages-api/static-1.16536",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "draft-content-plugins": "/draft-content-plugins/static-1.29199",
  "sequences-lib": "/sequences-lib/static-1.8823",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "meetings-client-types": "/meetings-client-types/static-1.4094",
  "meetings-core": "/meetings-core/static-1.808",
  "advanced-menus-core": "/advanced-menus-core/static-1.15859",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12602",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35252",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8680",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15858",
  "simple-menus-lib": "/simple-menus-lib/static-1.17375"
}
};
